import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';
import _isEmpty from 'lodash/isEmpty';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Heartfill from 'yoda-core-components/lib/assets/svg/Heartfill.svg';
import Heart from 'yoda-core-components/lib/assets/svg/Heart.svg';
import SflError from 'yoda-core-components/lib/assets/svg/SflError.svg';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';
import * as savedItemActions from '../../actions/SavedItemAction';
import config from '../ProductCard/ProductCard.config';
import analyticsActions from '../../actions/AnalyticsAction';
import saveForLaterConfig from './SaveForLater.config';
import * as styles from './SaveForLater.css';

const cx = classNames.bind(styles);

let SFLtimeout = null;
let prevInstance = null;

export class SaveForLater extends Component {
    static propTypes = {
        actions: PropTypes.object,
        savedItemStatus: PropTypes.object, // eslint-disable-line
        deviceType: PropTypes.object,
        cardType: PropTypes.string,
        ppId: PropTypes.string,
        skuId: PropTypes.string,
        isFirstProduct: PropTypes.bool,
        savedItems: PropTypes.array,
    };

    static defaultProps = {
        actions: {},
        savedItemStatus: null,
        cardType: config.cardTypes.GRID,
        ppId: null,
        skuId: null,
        savedItems: {},
        isFirstProduct: false,
        deviceType: {
            isMobile: false,
            isTablet: false,
            isDesktop: false,
        },
    };

    constructor() {
        super();
        this.state = {
            overlayText: null,
            isSaved: false,
            isInProgress: false,
            hasMounted: false,
        };
        this.canProcess = true;
        this.saveorDeleteItem = this.saveorDeleteItem.bind(this);
        this.onHover = this.onHover.bind(this);
        this.onLeave = this.onLeave.bind(this);
        this.resetStatusAndLabel = this.resetStatusAndLabel.bind(this);
    }

    componentWillMount() {
        /* istanbul ignore next */
        if (
            !__SERVER__ &&
            _isEmpty(this.props.savedItems) &&
            !Cookies.load('FSFL') &&
            this.props.isFirstProduct
        ) {
            Cookies.save('FSFL', 'yes');
        }
    }

    componentDidMount() {
        /* eslint-disable react/no-did-mount-set-state */
        this.setState({ hasMounted: true });
    }

    componentWillReceiveProps(nextProps) {
        const savedItemStatus = (nextProps.savedItemStatus || []).find(
            (obj) => obj.ppId === this.props.ppId
        );
        if (savedItemStatus && this.canProcess) {
            if (savedItemStatus.isSuccess) {
                if (savedItemStatus.action === 'add') {
                    const addedText = (
                        <div>
                            <div className={cx('success')}>Added to Favorites</div>
                            <a className={cx('link')} href={saveForLaterConfig.url.SAVEDLISTFAV}>
                                View Favorites
                            </a>
                        </div>
                    );

                    this.setState({
                        isSaved: true,
                        overlayText: addedText,
                    });
                } else if (savedItemStatus.action === 'remove') {
                    this.setState({
                        isSaved: false,
                        overlayText: null,
                    });
                }
            } else {
                const errorMessage =
                    savedItemStatus.errorMessage || 'Item could not be saved/removed';
                this.props.actions.triggerFormError([
                    {
                        errorDescription: errorMessage.toLowerCase(),
                    },
                ]);
                this.setState({
                    overlayText: (
                        <div>
                            <div>
                                <Icon
                                    iconType="svg"
                                    automationId="save-for-later-automation-with-fil-error"
                                    width="32px"
                                    height="32px"
                                    viewBox="0 0 32 32"
                                    key="error"
                                >
                                    <SflError />
                                </Icon>
                            </div>
                            <div className={cx('error')}>{errorMessage}</div>
                        </div>
                    ),
                });
            }
            if (SFLtimeout && prevInstance !== this) {
                prevInstance.resetStatusAndLabel();
                SFLtimeout = clearTimeout(SFLtimeout);
                prevInstance = null;
            }
            SFLtimeout = setTimeout(this.resetStatusAndLabel, 3000);
            prevInstance = this;
            this.canProcess = false;
        }

        if (nextProps.savedItems && (!savedItemStatus || _isEmpty(savedItemStatus))) {
            const isSaved = nextProps.savedItems[this.props.ppId];
            /* istanbul ignore next */
            if (isSaved) {
                this.setState({
                    isSaved: true,
                });
            } else if (this.state.isSaved) {
                this.setState({
                    isSaved: false,
                });
            }
        }
    }

    componentWillUnmount() {
        /* istanbul ignore next */
        if (this.timerhandle) {
            // observed memory leak warning .. added this to handle that warning
            clearTimeout(this.timerhandle);
            this.timerhandle = null;
        }
    }

    onHover() {
        if (this.state.isInProgress === false) {
            const fav = (this.props.savedItems || {})[this.props.ppId];
            const overlayText = fav ? 'Remove Favorite' : 'Favorite';
            this.setState({
                overlayText,
            });
        }
    }

    onLeave() {
        if (this.state.isInProgress === false) {
            this.setState({
                overlayText: null,
            });
        }
    }

    resetStatusAndLabel() {
        this.props.actions.resetStatus(this.props.ppId);
        this.resetLabel();
        this.canProcess = true;
    }

    saveorDeleteItem(e) {
        e.preventDefault();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        if (this.state.isInProgress === false) {
            this.setState({
                overlayText: <Loader automationId="test-automation-sfl-loader" />,
                isInProgress: true,
            });
            const fav = (this.props.savedItems || {})[this.props.ppId];
            if (fav) {
                this.deleteItem(fav.id);
            } else {
                this.saveItem();
            }
        }
    }

    saveItem() {
        this.props.actions.addItem([
            {
                product: {
                    id: this.props.ppId,
                },
                itemId: this.props.skuId,
                quantity: 1,
            },
        ]);
    }

    deleteItem(id) {
        this.props.actions.removeItem({
            ppId: this.props.ppId,
            id,
        });
    }

    resetLabel() {
        this.setState({
            isInProgress: false,
            overlayText: null,
        });
    }

    render() {
        const displayText = this.state.overlayText;
        let { isSaved } = this.state;

        // TODO: Need to find a better way because it causes an extra re-rerndering.
        if (!this.state.hasMounted) {
            return null;
        }
        /* istanbul ignore next */
        const extraMargin = this.props.cardType === config.cardTypes.GRID ? 'extraMargin' : '';
        if (this.props.savedItems) {
            const isSavedin = this.props.savedItems[this.props.ppId];
            if (isSavedin) {
                isSaved = true;
            }
        }

        const tooltip = () => {
            if (displayText) {
                const tooltipClass =
                    this.props.cardType === config.cardTypes.LIST
                        ? 'saveTooltipRight'
                        : 'saveTooltipBottom';
                return (
                    <div className={cx(tooltipClass)}>
                        <div className={cx('tooltipContent')}>{displayText}</div>
                    </div>
                );
            }

            return '';
        };
        const sflButtonKey = `saveForLater${this.props.ppId}${this.props.cardType}`;
        const savedIconKey = `saved${this.props.ppId}${this.props.cardType}`;
        const unsavedIconKey = `unsaved${this.props.ppId}${this.props.cardType}`;
        const windowWidth = !__SERVER__ && window.innerWidth;
        return (
            <div className={styles.saveForLater}>
                {this.props.deviceType.isDesktop ? (
                    <button
                        onClick={(e) => this.saveorDeleteItem(e)}
                        className={cx('sflButtonStyle', extraMargin)}
                        onMouseOver={() => this.onHover()}
                        onMouseLeave={() => this.onLeave()}
                        data-automation-id="save-for-later-btn"
                        key={sflButtonKey}
                    >
                        {isSaved ? (
                            windowWidth && windowWidth >= 1440 ? (
                                <Icon
                                    iconType="svg"
                                    automationId="save-for-later-automation-with-fil"
                                    width="38px"
                                    height="38px"
                                    viewBox="0 0 38 38"
                                    key={savedIconKey}
                                >
                                    <Heartfill />
                                </Icon>
                            ) : (
                                <Icon
                                    iconType="svg"
                                    automationId="save-for-later-automation-with-fil"
                                    width="32px"
                                    height="32px"
                                    viewBox="0 0 32 32"
                                    key={savedIconKey}
                                >
                                    <Heartfill />
                                </Icon>
                            )
                        ) : windowWidth && windowWidth >= 1440 ? (
                            <Icon
                                iconType="svg"
                                automationId="save-for-later-automation"
                                width="38px"
                                height="38px"
                                viewBox="0 0 38 38"
                                key={unsavedIconKey}
                            >
                                <Heart />
                            </Icon>
                        ) : (
                            <Icon
                                iconType="svg"
                                automationId="save-for-later-automation"
                                width="32px"
                                height="32px"
                                viewBox="0 0 32 32"
                                key={unsavedIconKey}
                            >
                                <Heart />
                            </Icon>
                        )}
                    </button>
                ) : (
                    <button
                        onClick={(e) => this.saveorDeleteItem(e)}
                        className={cx('sflButtonStyle', extraMargin)}
                        data-automation-id="save-for-later-btn"
                        key={sflButtonKey}
                    >
                        {isSaved ? (
                            <Icon
                                iconType="svg"
                                automationId="save-for-later-automation-with-fil"
                                width="28px"
                                height="28px"
                                viewBox="0 0 28 28"
                                key={savedIconKey}
                            >
                                <Heartfill />
                            </Icon>
                        ) : (
                            <Icon
                                iconType="svg"
                                automationId="save-for-later-automation"
                                width="28px"
                                height="28px"
                                viewBox="0 0 28 28"
                                key={unsavedIconKey}
                            >
                                <Heart />
                            </Icon>
                        )}
                    </button>
                )}
                {tooltip()}
            </div>
        );
    }
}

const mapStateToProps = (store) => ({
    savedItemStatus: store.savedItemStatus,
    savedItems: store.savedItems,
    deviceType: store.context ? store.context.deviceType : {},
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...savedItemActions, ...analyticsActions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SaveForLater);
